module.exports = __webpack_public_path__ + "media/src/fonts/uni-neue/uni-neue-100-thin-italic-b82382bbfb61913249e9b2c56d3648ef.woff";